import React from 'react';
import _ from 'lodash';

import * as types from './types';
import { useLookUpTier1ReturnAuthorizationModalLazyQuery } from 'generated/graphql';
import { BulkReceiveSpecificReturnAuthorizationsModal } from 'modules';



export interface IRecord {
  id: string;
  identifier: string;
  items: BulkReceiveSpecificReturnAuthorizationsModal.IItemReceipt[];
}

export function useLookUpReturnAuthorization() {
  const [fnQuery, tuple] = useLookUpTier1ReturnAuthorizationModalLazyQuery({});

  const fnWrappedQuery = React.useCallback(
    async (formState: types.IFormState): Promise<IRecord[]> => {
      const result = await fnQuery({
        variables: {
          searchText: _.trim(formState.value)
        }
      });

      const returnAuthorizations = result.data?.tier1ReturnAuthorizations.nodes ?? [];
      const allRecords = _.map(returnAuthorizations, (auth): IRecord[] => [
        {
          id: auth.id,
          identifier: auth.group.referenceNumber,
          items: auth.group.returnAuthorizations.nodes
            .map(rma => ({
              returnAuthorizationId: rma.id,
              serialNumber: rma.expectedSerialNumber,
              isReceived: !_.isNil(rma.itemReceipt),
              item: {
                id: rma.item.id,
                displayName: `${rma.item.name} ${rma.item.sku}`
              },
              store: {
                id: auth.group.store.id,
                displayName: auth.group.store.name
              }
            }))
            .filter(item => !item.isReceived)
        }
      ]);

      const flattened = _.flatten(allRecords);
      return _.uniqBy(flattened, f => f.identifier);
    },
    [fnQuery]
  );

  return React.useMemo(
    () => [
      fnWrappedQuery,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedQuery,
      tuple
    ]
  );
}
